import axios from 'axios';
import MatrixConfig from '../entity/matrix-config.entity';

export default class MatrixConfigService {
  public static getMatrixConfig(): Promise<MatrixConfig> {
    return axios.get('/api/matrix-configs').then(({ data }: any) => new MatrixConfig(data));
  }

  public static updateMatrixConfig(matrixConfig: MatrixConfig): Promise<void> {
    return axios.put(`/api/matrix-configs/${matrixConfig.id}`, matrixConfig);
  }
}
